import urls  from "./init-config";

let _env = urls.uat;

if (_env.production) {
  _env = {
    ..._env,
    ...urls.production
  }
}


export const environment = _env;